import { Application } from "@components/application";
import React from "react";
import ReactDOM from "react-dom/client";

import moment from "moment";
import "moment/locale/id";

import "./assets/styles/main.css";

moment.locale("id");

window.publishEvent = (eventName, data) => {
  window.dispatchEvent(new MessageEvent(eventName, { data }));
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Application />
  </React.StrictMode>
);
